export const customControlTemplate = `
<div class="root">  
<div hidden class="field-list-label">
  <label>Επιλογή πεδίων</label> 
  <label wj-part="g-flds"></label>  
</div>  
<label>Επιλογή πεδίων:</label> 
<div class="field-list pad">  
  <div wj-part="d-fields"></div>  
</div>  
<div hidden class="drag-areas-label">  
  <label wj-part="g-drag"></label>  
</div>  
<div class="filter-list pad">  
  <label>  
    <span class="wj-glyph wj-glyph-filter"></span>   
    <span hidden wj-part="g-flt"></span>
    <span>Φίλτρα</span> 
  </label>  
  <div wj-part="d-filters"></div>  
</div>  
<div class="column-list pad bdr-left">  
  <label>  
    <span class="wj-glyph">⫴</span>   
    <span hidden wj-part="g-cols"></span>  
    <span>Στήλες</span> 
  </label>  
  <div wj-part="d-cols"></div>  
</div>  
<div class="row-list pad bdr-top">  
  <label>  
    <span class="wj-glyph">≡</span>   
    <span hidden wj-part="g-rows"></span>  
    <span>Γραμμές</span> 
  </label>  
  <div wj-part="d-rows"></div>  
</div>  
<div class="values-list pad bdr-left bdr-top">  
  <label>  
    <span class="wj-glyph">Σ</span>   
    <span hidden wj-part="g-vals"></span>  
    <span>Τιμές</span> 
  </label>  
  <div wj-part="d-vals"></div>  
</div>  
<div wj-part="d-prog" class="progress-bar"></div> 
<div hidden class="control-area">  
  <label hidden>  
    <input hidden wj-part="chk-defer" type="checkbox">   
    <span wj-part="g-defer">Defer Updates</span>  
  </label>  
  <button hidden wj-part="btn-update" class="wj-btn wj-state-disabled" type="button" disabled>
    Update  
  </button>  
</div>  
</div>`;
